import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  IconName,
  Text,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useAuthenticationPrompt} from '../../../../features/Authentication/AuthenticationProvider/AuthenticationProvider';

export const FlyoutLoggedOut: React.FC = () => {
  const {t} = useTranslation();
  const {showUserAuthenticationPrompt} = useAuthenticationPrompt();

  return (
    <>
      <Section>
        <Headline>{t('You are not logged in yet')}</Headline>
        <Button
          onClick={() => {
            showUserAuthenticationPrompt({includeCheckoutSession: false});
          }}
        >
          {t('Log in')}
        </Button>
      </Section>
      <HorizontalRuler />
      <Section>
        <Usps>
          <Usp
            icon={GenericIconName.UspFreeShipping}
            text={t('Track your orders')}
          />
          <Usp icon={GenericIconName.Heart} text={t('Like your favorites')} />
        </Usps>
      </Section>
    </>
  );
};

const Usp: React.FC<{icon: IconName; text: string}> = ({icon, text}) => {
  return (
    <UspContainer>
      <Icon asset={icon} size="M" />
      <Text weight="bold">{text}</Text>
    </UspContainer>
  );
};

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 400px;
  padding: 24px;
`;

const Headline = styled(Text)`
  text-align: center;
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.bold};
`;

const HorizontalRuler = styled.hr`
  border-top: 0px;
  box-shadow: inset 0 -1px 0 0 ${COLORS.Grey3};
`;

const Usps = styled.div`
  display: flex;
  gap: 16px;
`;

const UspContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
